import React, { Component } from "react";

import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withAppState, getAppState } from "../../state";
import { getSdk } from "../../services/sdkService";
import { config } from "../../config/config";
import {
  Title,
  NextEpisode,
  PauseScreen,
  EpisodesSelectorScreen,
  Tracks,
  Modal,
  Filmstrip,
  withFocusable,
  PlaybackRate,
  Loading,
  ControlsSettings,
  Controls
} from "../../services/visualLibraryService";
import { PlayerShadow, ButtonSkipIntroStyled } from "../Player/styles/Styled";
import {
  playerUiStates,
  changeState,
  onStateEnter,
  setPlayerLoadTimer,
  destroyPlayerLoadTimer,
  showPlayer,
  hidePlayer,
  startNextEpisodeCountDown,
  clearNextEpisodeCountDown
} from "../Player/playerStates";
import { getLogger } from "../../utils/logger";
import Logo from "../../components/Logo";
import { updateTracksState, extendTrackInfo } from "../Player/tracks";
import { checkDevice, sendMaxDevicesReport } from "../Player/devices";
import { getPlayerErrorMessage, getPlayerErrorMessageHeading, sendPlayerErrorReport } from "../Player/playerErrors";
import { getSeasonsAndEpisodesList, getVideoData } from "../../utils/mediaDataRetrieval";
import { sendUserEvent } from "../../services/analyticsService";
import { Player, PlayerEvent } from "bitmovin-player";
import { SubtitleOverlay, SeekBar, UIContainer, UIManager } from "bitmovin-player-ui";
import { i18n } from "../../services/i18nService";
import { resolution } from "../../config/ui/resolutionConfig";
import { getEpisodeLabel } from "../../services/copyService";
import { showForceLogoutError } from "../../services/modalsService";
import { getErrorCode, createErrorMapper } from "./bitmovinErrorMapper";
import "./style.css";
import {
  Wrapper,
  PlayerDiv,
  LowerPlayerControls,
  PlayPauseToggle,
  ToggleBtn,
  FillBtnPlay,
  FillBtnPause,
  CurrentPlay,
  TotalPlayTime,
  CurrentAndTotalPlaySpan,
  ProgressBarContainer,
  ProgressBar,
  ControlsSettingsStyled,
  LabelDiv,
  LabelStyled,
  ControlSettingsBtn,
  FillBtnBack,
  FillBtnLanguage,
  FillBtnStart,
  FillBtnEpisode
} from "./styled";
import { ButtonStyled } from "../../components/ModalSettings/styles/Styled";
import { isUserAccountActive } from "../../services/accountStatusService";
import {isFVODFreeToAir} from "../../utils/fvodUtils"

let sdk = null;
let nextEpisodeData = null;
let locationState;
let Logger;
const PLAY_FROM_NEXT_EPISODE = "player_next_episode";
const PLAY_FROM_EPISODE_SELECTOR = "player_episode_selector";
const SKIP_INTRO_BUTTON_FOCUS_PATH = "skipIntroButton";
const SKIP_OUTRO_DISMISS_BUTTON_FOCUS_PATH = "skipOutroDismissButton";
const BUTTON_DISMISS_OUTRO_FOCUS_PATH = "buttonDismissOutroFocusPath";
const EPISODEFOCUS = "episodesCarousel";
const SEASONFOCUS = "seasonsCarousel";
const FilmstripFocus = withFocusable(Filmstrip);
const ButtonSkipIntroFocus = withFocusable(ButtonSkipIntroStyled);
const ButtonFocus = withFocusable(ButtonStyled);
const defaultFocusPath = "video";

var hidden, visibilityChange;

if (typeof document.hidden !== "undefined") {
  // To support the standard web browser engine
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  // To support the webkit engine
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}
class PlayerBitMovin extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    sdk = getSdk();
    Logger = getLogger();
    sdk.playerManager.destroy();
    locationState = this.props.location.state;
    this.state = {
      player: null,
      isPlayerLoaded: false,
      isPlaying: true,
      isSeeked: false,
      seekedTime: 0,
      duration: "00:00",
      currentTime: "00:00",
      currentTimeInSeconds: 0,
      totalTimeInSeconds: 0,
      showPauseScreen: false,
      playbackRate: 0,
      margin: i18n.getDirection() === "ltr" ? 2 : 1,
      selectBtn: 0,
      totalBtns:
        locationState.videoType === "series"
          ? 4
          : locationState.videoType === "trailer"
          ? 1
          : locationState.isLive
          ? 2
          : 3,
      textLabels:
        locationState.videoType !== "trailer"
          ? [
              "",
              i18n.get("global.back"),
              i18n.get("pages.player.settings.audioSubtitles"),
              i18n.get("global.playFromBeginning"),
              i18n.get("global.media.episodes")
            ]
          : ["", i18n.get("global.back")],
      playerBuffering: true,
      episodeSelectorLoading: false,
      openTracksAndAudio: false,
      showFilmStrip: false,
      subtitleTracks: null,
      audioTracks: null,
      filmstripData: null,
      nextEpisodePlay: false,
      skipIntroPlay: false,
      skipOutroPlay: false,
      currentSubtitleID: null,
      isMaxDeviceReached: false,
      showPlayerControls: true,
      isPlayFromEpisodes: false,
      showEpisodesLists: false,
      errorMessage: null,
      errorMessageHeading: null,
      isTryToplayFromResume: true,
      title: locationState.title,
      seriesTitle: locationState.seriesTitle,
      episodeLabel: locationState.episodeLabel,
      description: locationState.description,
      tvSeasonNumber: locationState.tvSeasonNumber,
      tvSeasonEpisodeNumber: locationState.tvSeasonEpisodeNumber,
      nextEpisodeCountDown: config.get().player.nextEpisodeCountDown,
      skipOutroCountDown: config.get().player.skipOutroCountDown
    };

    this.config = {
      refCanStartPlayback: null
    };
    this.wheelState = "idle";
    this.preferredAudioLanguage = config.get().preferredAudioLanguage;
    this.preferredSubtitlesLanguage = config.get().preferredSubtitlesLanguage;
    this.playbackPercentages = [...config.get().player.playbackPercentages];
    this.timeToHideUI = config.get().player.timeToHideUI;
    this.timeToShowPauseScreen = config.get().player.timeToShowPauseScreen;

    createErrorMapper();
    this.filmstrip = null;
    this.skipIntroClicked = false;
    this.skipOutroClicked = false;
    this.isNextEpisodeRequested = false;
    this.errorButtonClose = null;
    this.dismissOutroInterval = null;
    this.showPauseScreenInterval = null;
    this.showHidePlayerControls = null;
    this.previousSecond = null;
    this.playbackTimes = null;
    this.appFlow = i18n.getDirection(); //LTR or RTL
    this.playbackIconName = "";
    this.isHeartBeatLoaded = null;
    this.bindings();

    document.addEventListener(visibilityChange, this.onVisibilityChange);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activePanel !== this.state.activePanel) {
      Logger.log(PlayerBitMovin.getPlayerLog(this.state), "Player");
      if (onStateEnter[this.state.activePanel]) {
        onStateEnter[this.state.activePanel].call(this);
      }
      this.updateFocus();
    }
  }

  async checkMaxDevices() {
   
    const { maxDevices } = config.get().featureToggles;

    if (maxDevices && locationState.videoType !== "trailer") {
      try {
        const { freeDeviceSlotsExist, deviceAlreadyRegistered } = await checkDevice.call(this);
        if (!deviceAlreadyRegistered && !freeDeviceSlotsExist) {
          this.showErrorModal(i18n.get("pages.player.errors.maximumDevicesReached"));
          sendMaxDevicesReport.call(this);
          return true;
        }
      } catch (e) {
        await this.props.stateActions.setForceLogout(e);
        // if Force logout show the popup
        if (!!getAppState().forceLogout) {
          this.props.resumeNavigation();
          await showForceLogoutError.call(this);
          return;
        }
        this.showErrorModal(e.message);
        return true;
      }
    }
    return false;
  }

  async componentDidMount() {

    sdk = await getSdk();

    if (locationState.playFrom === "cw_home") {
      await this.loadContent();
    }
    await this.updateConfig();

    (async () => {
      try {
        const isMaxDevice = await this.checkMaxDevices();
        this.setState({ isMaxDeviceReached: isMaxDevice });
        if (!!getAppState().forceLogout) {
          this.props.resumeNavigation();
          await showForceLogoutError.call(this);
          return;
        }
        if (this.state.isMaxDeviceReached === true) {
          return;
        }
        let { onRef } = this.props;
        showPlayer();
        this.clearUserMediaCached();
        onRef(this);
        if (locationState.playFrom === "cw_home") {
          await this.loadContent();
        }
        if (locationState.videoType === "series") {
          if (!locationState.seasonsList && !locationState.episodesList) {
            await this.checkAndLoadSeriesData();
          }
        }
      } catch (e) {
        await this.props.stateActions.setForceLogout(e);
        // if Force logout show the popup
        if (!!getAppState().forceLogout) {
          this.props.resumeNavigation();
          await showForceLogoutError.call(this);
          return;
        }
        this.showErrorModal(e.message);
        return;
      }
      try {
        Logger.log(this.config.manifest, "Manifest");
        // adding freeToAir in this.config, if it is available in locationState.isFreeToAir as true
        if(locationState?.isFreeToAir){
          this.config.freeToAir = true;
        }
        console.clear()
        console.log("this.config", this.config)
        this.setupPlayer();
      } catch (e) {
        Logger.log(
          `Requesting error message for error: ${e.code} after failure in playerManager.setup`,
          "Player.componentDidMount"
        );
      }
      document.addEventListener("keyup", this.handleRemoteKeys, false);
      document.addEventListener("keydown", this.handleRemoteKeysFilmstrip, false);
      !!getAppState().globalModal && this.props.stateActions.hideGlobalModal();

      const seriesTitle = locationState.seriesId
        ? (await sdk.mediaManager.getTitleText(locationState.seriesId)).title
        : null;

      this.config.playbackAnalytics = {
        ...this.config.playbackAnalytics,
        title: seriesTitle || this.state.title
      };
    })();
  }

  componentWillUnmount() {
    if (this.state.isMaxDeviceReached === false) {
      document.removeEventListener("keyup", this.handleRemoteKeys, false);
      document.removeEventListener("keydown", this.handleRemoteKeysFilmstrip, false);
      hidePlayer();
      sdk.playerManager.stop();
      sdk.playerManager.destroy();
      //Removing all Event Handlers
      if (this.player && this.player !== null) {
        this.player.off(PlayerEvent.Seek, this.seekEventHandler);
        this.player.off(PlayerEvent.Playing, this.playEventHandler);
        this.player.off(PlayerEvent.PlaybackFinished, this.playbackFinishedEventHandler);
        this.player.off(PlayerEvent.TimeChanged, this.timeChangedEventHandler);
        this.player.off(PlayerEvent.Error, this.playerErrorEventHandler);
        this.player.off(PlayerEvent.StallStarted, this.stallStartedEventHandler);
        this.player.off(PlayerEvent.StallEnded, this.stallEndedEventHandler);
        document.removeEventListener(visibilityChange, this.onVisibilityChange);
      }
      this.player && this.player.off(PlayerEvent.Seeked, this.seekedHandler);
      destroyPlayerLoadTimer.call(this);
      this.player && this.player.unload();
      this.player && this.player.destroy();
      this.player && this.props.resumeNavigation();
      // this.destroyPlayer();
    }
  }

  /**
   * Request content for playback (only when come to the player from the CW of the Layout)
   */
  async loadContent() {
    const { id, progress, seriesId, moduleId, is4K } = locationState.videoConfig;
    try {
      const videoData = await getVideoData(id, progress, seriesId, moduleId, is4K);
      sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
      Object.assign(locationState, videoData);
      this.setState({
        title: locationState.title,
        seriesTitle: locationState.seriesTitle,
        episodeLabel: locationState.episodeLabel,
        description: locationState.description,
        tvSeasonNumber: locationState.tvSeasonNumber,
        tvSeasonEpisodeNumber: locationState.tvSeasonEpisodeNumber
      });
    } catch (e) {
      await this.props.stateActions.setForceLogout(e);
      // if Force logout show the popup
      if (!!getAppState().forceLogout) {
        this.props.resumeNavigation();
        await showForceLogoutError.call(this);
        return;
      }
    }
    await this.updateConfig();
    let resumeFrom = this.config.playbackTime !== 0 ? this.config.playbackTime : 0;
    if (resumeFrom && resumeFrom !== 0 && this.state.isTryToplayFromResume === true) {
      this.setState({
        currentTime: this.toMinutesAndSeconds(resumeFrom)
      });
    }
  }

  /**
   * Updates config information to send to the player
   */
  async updateConfig() {
    Object.assign(this.config, {
      releasePids: locationState.releasePid,
      releaseUrl: locationState.releaseUrl,
      videoType: locationState.videoType,
      manifest: locationState.manifest,
      playbackTime: locationState["playbackTime"],
      id: locationState.id,
      has4K: locationState.has4K,
      externalSubtitles: locationState.externalSubtitles,
      isLive: locationState.isLive,
      addonContent: locationState.addonContent || "starz",
      ...(config.get().featureToggles.skipIntro &&
        locationState.videoType === "series" && {
          credits: await this.getCredits(locationState.credits, locationState.mediaGuid)
        }),
      playbackAnalytics: {
        season: locationState.tvSeasonNumber || 0,
        episode: locationState.tvSeasonEpisodeNumber || 0,
        mediaGuid: locationState.mediaGuid,
        duration: locationState.duration,
        genre: locationState.genre,
        is4KEnabled: this.is4KSessionSelectedQuality() && locationState.has4K,
        playFrom: locationState.playFrom,
        resume: !!locationState["playbackTime"],
        title: locationState.seriesTitle || this.state.title
      }
    });
    if (locationState.videoType === "series") {
      if (locationState.seriesId) {
        this.config.seriesId = locationState.seriesId;
      }
      this.config.seasonNumber = locationState.tvSeasonNumber || 1;
      this.config.episodeNumber = locationState.tvSeasonEpisodeNumber || 1;
    }
  }
  showProgressBar() {
    if (this.state.showPauseScreen === true) {
      this.setState({
        showPauseScreen: false
      });
    }
    this.showControls();
  }

  showBar() {
    clearTimeout(this.showHidePlayerControls);
    this.setState({
      showPlayerControls: true
    });
  }

  showControls() {
    clearTimeout(this.showHidePlayerControls);
    this.setState({
      showPlayerControls: true
    });

    if (!this.state.showFilmStrip) {
      this.showHidePlayerControls = setTimeout(() => {
        this.setState({
          showPlayerControls: false,
          openTracksAndAudio: false
        });
      }, this.timeToHideUI);
    }
  }

  backHandler() {
    this.player && this.player.pause();
    locationState.videoType !== "trailer" && this.state.totalTimeInSeconds && this.checkPercentageTimePlayed();
    sdk.playerManager.destroy();

    setTimeout(() => {
      this.props.history.goBack();
    }, 100);
  }
  back() {
    this.player && document.removeEventListener("keyup", this.handleRemoteKeys, false);
    this.player && document.removeEventListener("keydown", this.handleRemoteKeysFilmstrip, false);
    this.backHandler();
  }
  maxDeviceBack() {
    sdk.playerManager.destroy();
    setTimeout(() => this.props.history.goBack(), 100);
  }

  openLanguage() {
    this.loadSubtitlesTracks();
    this.loadAudioTracks();
    this.setState({
      openTracksAndAudio: true
    });
  }

  playFromBegining() {
    this.playFromStart();
  }

  openEpisodeList() {
    this.setState({
      openTracksAndAudio: false,
      showPlayerControls: false,
      showFilmStrip: false
    });
    // episodes button
    this.setState({
      showEpisodesLists: true
    });
    this.player.pause();
    sdk.playerManager.pause();
    const self = this;
    setTimeout(() => {
      self.props.setFocus(EPISODEFOCUS);
    }, 500);

    this.setState({ playerBuffering: false }, () => {
      changeState.call(this, playerUiStates.EPISODE_SELECTOR);
    });
  }

  async checkAndLoadSeriesData() {
    const seriesData = await getSeasonsAndEpisodesList(locationState.seriesId);
    this.setState({ playerBuffering: false, ...seriesData }, () => {
      changeState.call(this, playerUiStates.EPISODE_SELECTOR);
    });
  }

  handleRemoteKeys(event) {
    const { isLive } = locationState;
    this.wheelState = "idle";
    if (this.state.playerBuffering) return;
    if (this.state.nextEpisodePlay) return;
    if (this.state.skipOutroPlay) return;
    if (this.shouldShowLoading()) return;
    if (event.keyCode === 13) {
      // OK button
      if (this.state.showEpisodesLists || this.state.openTracksAndAudio) return;

      if (this.state.skipIntroPlay === true) {
        this.skipIntroAction();
        return;
      }

      if (this.state.selectBtn === 0 && this.shouldShowSkipOutro() === false) {
        this.togglePausePlay();
      } else if (!this.state.showFilmStrip && this.state.selectBtn === 1) {
        sdk.playerManager.stop();
        this.backHandler();
        // back button
      } else if (!this.state.showFilmStrip && this.state.selectBtn === 2) {
        this.loadSubtitlesTracks();
        this.loadAudioTracks();
        this.setState({
          openTracksAndAudio: true
        });
      } else if (!this.state.showFilmStrip && this.state.selectBtn === 3) {
        // start play button
        this.playFromStart();
      } else if (!this.state.showFilmStrip && locationState.videoType === "series" && this.state.selectBtn === 4) {
        // episodes button
        this.openEpisodeList();
      }
    } else if (event.keyCode === 38) {
      // up button
      this.showControls();
      if (
        this.state.isPlaying === false ||
        this.state.showEpisodesLists ||
        this.state.openTracksAndAudio ||
        this.state.showFilmStrip ||
        this.state.skipIntroPlay
      )
        return;
      if (this.state.selectBtn === 0) {
        this.setState({
          selectBtn: 1,
          margin: i18n.getDirection() === "ltr" ? 2 : 1
        });
      }
    } else if (event.keyCode === 40) {
      // down button
      this.showControls();
      if (
        this.state.showEpisodesLists ||
        this.state.openTracksAndAudio ||
        this.state.showFilmStrip ||
        this.state.skipIntroPlay
      )
        return;
      if (this.state.selectBtn > 0) {
        this.setState({
          selectBtn: 0,
          margin: i18n.getDirection() === "ltr" ? 2 : 1
        });
      }
    } else if (event.keyCode === 415) {
      // play button on remote
      if (!this.state.isSeeked && this.state.isPlaying === false) {
        this.setState({
          isPlaying: true,
          selectBtn: 0,
          showFilmStrip: false,
          openTracksAndAudio: false,
          showEpisodesLists: false
        });
        this.player.play();
        clearInterval(this.showPauseScreenInterval);
        this.setState({
          showPauseScreen: false
        });
        this.showControls();
      } else if (this.state.isSeeked) {
        this.player.pause();
        this.player.seek(this.state.seekedTime);
      }
    } else if (event.keyCode === 19) {
      //pause button on remote
      if (!this.state.isSeeked && this.state.isPlaying === true) {
        this.setState({
          isPlaying: false,
          selectBtn: 0,
          showFilmStrip: false,
          openTracksAndAudio: false,
          showEpisodesLists: false
        });
        !isLive && this.player.pause();
        this.showPauseScreenInterval = setInterval(() => {
          this.setState({
            showPauseScreen: true
          });
        }, this.timeToShowPauseScreen);
      }
    }
  }
  handleRemoteKeysFilmstrip(event) {
    const { isLive } = locationState;
    if (this.state.playerBuffering) return;
    if (this.state.nextEpisodePlay) return;
    if (this.state.skipOutroPlay) return;
    if (this.shouldShowLoading()) return;
    this.state.showFilmStrip && !locationState.isLive && this.player.pause();
    if (event.keyCode === 37) {
      //left button
      this.showControls();
      if (this.state.showEpisodesLists || this.state.openTracksAndAudio || this.state.skipIntroPlay) return;
      if (this.appFlow === "ltr" && !this.state.showFilmStrip && this.state.selectBtn > 1) {
        this.setState({
          selectBtn: this.state.selectBtn - 1,
          margin: this.state.margin - 4.5
        });
      } else if (
        this.appFlow === "rtl" &&
        !this.state.showFilmStrip &&
        this.state.selectBtn > 0 &&
        this.state.selectBtn < this.state.totalBtns
      ) {
        this.setState({
          selectBtn: this.state.selectBtn + 1,
          margin: this.state.margin + 4.5
        });
      } else if (this.state.selectBtn === 0) {
        !isLive && this.seekLeft();
      }
    } else if (event.keyCode === 39) {
      // right button
      this.showControls();
      if (this.state.showEpisodesLists || this.state.openTracksAndAudio || this.state.skipIntroPlay) return;

      if (
        this.appFlow === "ltr" &&
        !this.state.showFilmStrip &&
        this.state.selectBtn > 0 &&
        this.state.selectBtn < this.state.totalBtns
      ) {
        this.setState({
          selectBtn: this.state.selectBtn + 1,
          margin: this.state.margin + 4.5
        });
      } else if (this.appFlow === "rtl" && !this.state.showFilmStrip && this.state.selectBtn > 1) {
        this.setState({
          selectBtn: this.state.selectBtn - 1,
          margin: this.state.margin - 4.5
        });
      } else if (this.state.selectBtn === 0) {
        !isLive && this.seekRight();
      }
    }
    if (event.keyCode === 412) {
      //rewind button on remote
      this.state.selectBtn === 0 && this.seekLeft();
    } else if (event.keyCode === 417) {
      //forward button on remote
      this.state.selectBtn === 0 && this.seekRight();
    }
  }

  onVisibilityChange = () => {
    if (document.hidden) {
      // quit app
      sdk.playerManager.stop();
      sdk.playerManager.destroy();
      // this.player.stop();
      this.player.pause();
    } else {
      // display app
      return this?.backHandler();
    }
  };
  // getting internal bitmovin audio track
  loadAudioTracks() {
    const newState = {};
    const availableAudioTrack = this.player.getAvailableAudio();
    if (!this.state.audioTracks) {
      newState.audioTracks = extendTrackInfo(
        sdk.playerManager.getAvailableAudioTracks(availableAudioTrack),
        this.preferredAudioLanguage
      );
    }
    this.setState(newState);
    this.props.stateActions.hideGlobalModal();
  }

  /**
   * Gets the information for the subtitles menu and selects the selected subtitle in the menu
   */
  loadSubtitlesTracks() {
    const newState = {};
    const { isLive } = locationState;
    if (!this.state.subtitleTracks && !isLive) {
      newState.subtitleTracks = extendTrackInfo(
        sdk.playerManager.getAvailableSubtitleTracks(),
        this.preferredSubtitlesLanguage
      );
      for (let i = 0, l = newState.subtitleTracks.length; i < l; i++) {
        const track = newState.subtitleTracks[i];
      }
    } else if (isLive) {
      newState.subtitleTracks = [
        {
          language: "off",
          selected: true,
          title: "None"
        }
      ];
    } else if (this.state.subtitleTracks && !isLive) {
      newState.subtitleTracks = this.state.subtitleTracks;
    }
    this.setState(newState);
  }

  updateSubtitleContainerDirection = language => {
    if (language === "ar" || language === "ur") {
      const element = document.querySelector(".bmpui-container-wrapper");
      element.setAttribute("dir", "rtl");
      element.classList.add("sans-serif-font-family");
    } else {
      const element = document.querySelector(".bmpui-container-wrapper");
      element.setAttribute("dir", "ltr");
      element.classList.remove("sans-serif-font-family");
    }
  };

  /**
   * Selects audio and subtitle track
   * @param {Object} selectedTrack
   */
  selectTrack(selectedTrack) {
    if (selectedTrack.type === "TEXT") {
      let selectedSubtitle = null;
      if (selectedTrack.index >= 0) {
        try {
          this.player.subtitles.disable(this.state.currentSubtitleID);
        } catch (e) {}
        for (let i = 0; i < this.player.subtitles.list().length; i++) {
          selectedSubtitle = this.player.subtitles.list()[i];
          if (selectedTrack.language === selectedSubtitle.lang) {
            this.player.subtitles.enable(selectedSubtitle.id);
            this.setState({
              currentSubtitleID: selectedSubtitle.id,
              subtitleTracks: updateTracksState(this.state.subtitleTracks, selectedTrack)
            });
            sdk.playerManager.updatePreferences({ subtitles: selectedTrack.language });
            break;
          }
        }
        this.updateSubtitleContainerDirection(selectedTrack.language);
      } else {
        this.player.subtitles.disable(this.state.currentSubtitleID);
        this.setState({
          subtitleTracks: updateTracksState(this.state.subtitleTracks, selectedTrack)
        });
        sdk.playerManager.updatePreferences({ subtitles: selectedTrack.language });
      }
    } else {
      const availableAudioTrack = this.player.getAvailableAudio();
      this.player.setAudio(availableAudioTrack[selectedTrack.index].id);
      !locationState.isLive && sdk.playerManager.updatePreferences({ audio: selectedTrack.lang });
      this.setState({
        audioTracks: updateTracksState(this.state.audioTracks, selectedTrack)
      });
    }
  }

  async setupPlayer() {
    if (locationState.videoType === "series" && locationState.playFrom === "cw_home") {
      this.setState({
        totalBtns: 4
      });
    }
    const streamingUrl = locationState.manifest;
    await sdk.playerManager.setup(locationState);

    const playerConfig = {
      key: "9c89f7d3-2fe7-4986-aaaf-dacaf8f37b93",
      playback: {
        autoplay: true
      },
      ui: false, // disable the built-in UI
      adaptation: {
        desktop: {
          preload: true
        }
      }
    };

    this.loadSource(playerConfig, streamingUrl);

    if (locationState.videoType !== "trailer") {
      const preferredLanguage = await sdk.userManager.getPreferences();
      // TODO: Once this preferences needed outside the player it should be fetched along all the Application
      if (preferredLanguage.playback) {
        this.preferredAudioLanguage = preferredLanguage.playback.audio;
        this.preferredSubtitlesLanguage = preferredLanguage.playback.subtitles;
      }
    }
  }

  loadPreferredSubtitletracks() {
    let selectedSubtitle = null;
    for (let i = 0; i < this.player.subtitles.list().length; i++) {
      selectedSubtitle = this.player.subtitles.list()[i];
      if (this.preferredSubtitlesLanguage === selectedSubtitle.lang) {
        this.player.subtitles.enable(selectedSubtitle.id);
        this.setState({
          currentSubtitleID: selectedSubtitle.id
        });
        this.updateSubtitleContainerDirection(selectedSubtitle.lang);
        break;
      }
    }
  }
  //TODO : Audio Language user Prefered is updated
  loadPreferredAudiotracks() {
    const availableAudioTrack = this.player.getAvailableAudio();
    for (let i = 0; i < availableAudioTrack.length; i++) {
      if (this.preferredAudioLanguage === availableAudioTrack[i].lang) {
        this.player.setAudio(availableAudioTrack[i].id);
        break;
      }
    }
  }

  async loadSource(playerConfig, streamingUrl) {
    this.player = new Player(document.getElementById("av-player"), playerConfig);
    this.props.stateActions.setPlayer(this.player);
    this.props.stateActions.setPlayerConfig(this.config);
     this.readyEventHandlerTimeout = () => {
      sdk.playerManager.ready();
      clearNextEpisodeCountDown.call(this);
      Logger.log("LG Bitmovin player Ready", "Player.Ready");
      this.setState(
        {
          currentTime: this.toMinutesAndSeconds(this.config.playbackTime !== 0 ? this.config.playbackTime : 0)
        },
        this.setState({
          isPlayerLoaded: true,
          playbackState: "init"
        })
      );
      sdk.playerManager.stop(false);
      sdk.playerManager.configSuccess(this.config);

    };
    this.player.on(PlayerEvent.Ready,  this.readyEventHandlerTimeout);
    let playbackToken = "";
    if (locationState.videoType === "movie" || locationState.videoType === "series") {
      const requestBody = {
        releasePids: locationState.releasePid,
        protectionScheme: config.get().player.drmTechnology
      };
      try {
        playbackToken = await sdk.authenticationManager.getPlaybackToken(requestBody);
      } catch (e) {
        await this.props.stateActions.setForceLogout(e);
        // if Force logout show the popup
        if (!!getAppState().forceLogout) {
          this.props.resumeNavigation();
          await showForceLogoutError.call(this);
          return;
        }
      }
    }

    // Replacing Stream Cdn url http to https endpoints based onconfig
    console.log('config.get().player?.streamCDN?.twist', config.get().player?.streamCDN?.twist);
    const streamCDNInfo= Object.assign({}, ... config.get().player?.streamCDN?.twist && 
                         config.get().player?.streamCDN?.twist.filter(obj => streamingUrl.includes(obj.src)) );
    console.log('streamCDNInfo', streamCDNInfo);
    if (streamCDNInfo) {
      let regEx = new RegExp(`\\http\:\/\/${streamCDNInfo.src}\\b`, 'gi');
      streamingUrl = streamingUrl.replace(regEx,streamCDNInfo.target);
    }

    const source = {
      dash: streamingUrl,
      options: { startOffset: this.config.playbackTime !== 0 ? this.config.playbackTime : 0 },
      drm: {
        widevine: {
          
          LA_URL: "https://widevine-license.vudrm.tech/proxy",
          prepareMessage(keyMessage) {
            return JSON.stringify({
              token: playbackToken,
              drm_info: Array.apply(null, new Uint8Array(keyMessage.message))
            });
          }
        }
      },
      events: {
        [PlayerEvent.Error]: this.playerErrorEventHandler
      }
    };
    Logger.log("On Init event callback function is going to run. Is mounted:TRUE", "Player.onInit");
    Logger.log("Initializing player load timer", "Player.onInit");
    setPlayerLoadTimer.call(this);
    this.player
      .load(source)
      .then(() => {
        const subtitleUI = new UIContainer({
          components: [new SubtitleOverlay(), new SeekBar()]
        });
        this.player.on(PlayerEvent.Seek, this.seekEventHandler);
        destroyPlayerLoadTimer.call(this);

        // Launch the UI
        const uiManager = new UIManager(this.player, subtitleUI);
        this.player.play();
        this.getFilmStrip();
        this.loadSubtitlesTracks();
        this.loadAudioTracks();
        this.loadPreferredSubtitletracks();
        this.loadPreferredAudiotracks();
        // start playing event bitmovin
        // this.con
        this.player.on(PlayerEvent.Playing, this.playEventHandler);

        // playback finished event bitmovin
        this.player.on(PlayerEvent.PlaybackFinished, this.playbackFinishedEventHandler);

        // time update event bitmovin
        this.player.on(PlayerEvent.TimeChanged, this.timeChangedEventHandler);
      })
      .catch(e => {
        Logger.log(
          `Requesting error message for error: ${e} after failure in bitmovin player config`,
          "Player.loadSource"
        );
        destroyPlayerLoadTimer.call(this);
      });

    this.player.on(PlayerEvent.Error, this.playerErrorEventHandler);
    this.player.on(PlayerEvent.StallStarted, this.stallStartedEventHandler);
    this.player.on(PlayerEvent.StallEnded, this.stallEndedEventHandler);

      ///////////////// start : Analytics Youbora ///////////////
      const { playbackAnalytics } = config.get().featureToggles;
      !!playbackAnalytics  &&  (await sdk.playerManager.startPlaybackAnalytics(this.config));
       ///////////////// end : Analytics Youbora ///////////////
  }
  /**
   * After turning off the player load timer to avoid doubling errors, checks if any error code is received to get
   * its customized error message to show in a modal and sends an error report.
   * @param {Object} error - Error data
   */

  stallStartedEventHandler = e => {
    this.setState({
      playerBuffering: true
    });
    this.networkErrorTimeout = setTimeout(() => {
      this.playerErrorEventHandler({
        code: 1400
      });
    }, 10000);
    // setTimeout()
  };
  stallEndedEventHandler = e => {
    this.setState({
      playerBuffering: false
    });
    this.networkErrorTimeout && clearTimeout(this.networkErrorTimeout);
  };
  playerErrorHandler(error) {
    if (error && error.data) {
      const { sendReport = true } = error;
      try {
        Logger.log(`Player emitted an error ${error.code} with data: ${error.data.name}`, "Player.playerErrorHandler");
        destroyPlayerLoadTimer.call(this, false);
        Logger.log(`Requesting error message for error: ${error && error.code}`, "Player.playerErrorHandler");
        const message = error.code && getPlayerErrorMessage(error.code);
        const messageHeading = error.code && getPlayerErrorMessageHeading(error.code);
        // Next state checking is due to double errors that might come from sdk, such as related with DRM.
        !this.state.errorMessage && this.showErrorModal(message, messageHeading);
        sendReport && sendPlayerErrorReport.call(this, error);
        this.didErrorHappen = true;
      } catch (error) {
        Logger.log(`Requesting error message for error: ${error && error.code}`, "Player.playerErrorHandler");
        const message = getPlayerErrorMessage(error.code);
        this.showErrorModal(message);
      }
      sdk.playerManager.stop();
      sdk.playerManager.destroy();
    } else {
      Logger.log(`Player ignored an error ${error.code} with data: ${error.data.name}`, "Player.playerErrorHandler");
    }
  }

  static getPlayerLog(player) {
    const { playbackState, activePanel, currentTime, playerBuffering, duration, currentTimeInSeconds } = player;

    return {
      playbackState,
      activePanel,
      currentTime,
      playerBuffering,
      duration,
      currentTimeInSeconds
    };
  }

  showErrorModal(message, errorMessageHeading = null) {
    this.props.resumeNavigation();
    this.setState({ errorMessage: message, errorMessageHeading });
    this.errorButtonClose.props.setFocus();
  }

  checkTimeForSendEvent() {
    const { isLive, moduleId, videoType, seriesId } = locationState;
    if (this.state.currentTimeInSeconds !== this.previousSecond) {
      this.calculateTimes();
      const foundPlaybackTime = this.getPlaybackTimePercentIndex(this.state.currentTimeInSeconds);
      if (!isLive && this.playbackTimes.length > 0 && foundPlaybackTime > -1) {
        sendUserEvent({
          module_id: moduleId,
          id: this.config.id,
          action: "watch",
          value: this.playbackPercentages[foundPlaybackTime],
          ...(videoType === "series" && { parent_id: seriesId })
        });
        this.playbackPercentages.splice(0, foundPlaybackTime + 1);
      }
      this.previousSecond = this.state.currentTimeInSeconds;
    }
  }
  checkPercentageTimePlayed() {
    const { isLive, moduleId, videoType, seriesId } = locationState;
    videoType !== "trailer" &&
      !isLive &&
      sendUserEvent({
        module_id: moduleId,
        id: this.config.id,
        action: "stop",
        value: this.getPercentPlayed(),
        eventType: "watch",
        ...(videoType === "series" && { parent_id: seriesId })
      });
  }

  /**
   * Returns the percent played with two decimals
   * @returns {Number}
   */
  getPercentPlayed() {
    const percent = this.state.currentTimeInSeconds / this.state.totalTimeInSeconds;
    return percent.toFixed(2);
  }

  updateFocus() {
    const active = this.state.activePanel;
    switch (active) {
      case playerUiStates.NONE:
        this.currentFocus = defaultFocusPath;
        break;
      case playerUiStates.CONTROLS_PLAYING:
      case playerUiStates.CONTROLS_PAUSED:
        this.currentFocus =
          this.lastFocused || (locationState.isLive ? ControlsSettings.defaultFocusPath : Controls.defaultFocusPath);
        this.lastFocused = null;
        break;
      case playerUiStates.TRACKS:
        this.currentFocus = Tracks.defaultFocusPath;
        break;
      case playerUiStates.NEXT_EPISODE:
        this.currentFocus = NextEpisode.defaultFocusPath;
        break;
      case playerUiStates.EPISODE_SELECTOR:
        this.currentFocus = EpisodesSelectorScreen.defaultFocusPath;
        break;
      case playerUiStates.SKIP_INTRO:
        this.currentFocus = SKIP_INTRO_BUTTON_FOCUS_PATH;
        break;
      case playerUiStates.SKIP_OUTRO:
        this.currentFocus = BUTTON_DISMISS_OUTRO_FOCUS_PATH;
        break;
      default:
        this.currentFocus = defaultFocusPath;
        break;
    }
    this.props.setFocus(this.currentFocus);
  }

  calculateTimes() {
    if (this.state.totalTimeInSeconds) {
      this.playbackTimes = this.playbackPercentages.map(percentage => {
        return Math.floor(this.state.totalTimeInSeconds * percentage);
      });
    }
  }

  /**
   * Looks if the current percentage time played is in the percentages array.
   * This array (this.playbackTimes) has the percentages in which the user event will be sent.
   * @param {Number} currentTimeInSeconds
   * @returns {Number} Returns 0 if the index of the percent playing is in array or -1 if not
   */
  getPlaybackTimePercentIndex(currentTimeInSeconds) {
    const playbackTimeIndex = this.playbackTimes.findIndex(item => item > currentTimeInSeconds);

    if (this.playbackTimes.length > 1) {
      return playbackTimeIndex - 1;
    } else if (this.playbackTimes.length === 1) {
      return this.playbackTimes[0] < currentTimeInSeconds ? 0 : -1;
    }
    return -1;
  }

  bindings() {
    this.playEpisode = this.playEpisode.bind(this);
    this.shouldRenderPlaybackRate = this.shouldRenderPlaybackRate.bind(this);
    this.selectTrack = this.selectTrack.bind(this);
    this.getTimeMarkers = this.getTimeMarkers.bind(this);
    this.showSkipIntro = this.showSkipIntro.bind(this);
    this.showSkipOutro = this.showSkipOutro.bind(this);
    this.skipIntroAction = this.skipIntroAction.bind(this);
    this.getEpisodesList = this.getEpisodesList.bind(this);
    this.skipOutroAction = this.skipOutroAction.bind(this);
    this.dismissOutro = this.dismissOutro.bind(this);
    this.back = this.back.bind(this);
    this.getNextEpisode = this.getNextEpisode.bind(this);
    this.handleRemoteKeys = this.handleRemoteKeys.bind(this);
    this.handleRemoteKeysFilmstrip = this.handleRemoteKeysFilmstrip.bind(this);
    this.showProgressBar = this.showProgressBar.bind(this);
    this.showBar = this.showBar.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
  }

  onBack() {
    if (this.state.showEpisodesLists === true) {
      this.setState({
        showEpisodesLists: false
      });
      this.player.play();
      return true;
    } else if (this.state.openTracksAndAudio === true) {
      this.setState({
        openTracksAndAudio: false
      });
      return true;
    } else if (this.state.showPlayerControls === true) {
      this.setState({
        showPlayerControls: false
      });
      return true;
    } else {
      locationState.videoType !== "trailer" && this.state.totalTimeInSeconds && this.checkPercentageTimePlayed();
      return false;
    }
  }

  /**
   * Shows skip intro
   */
  showSkipIntro() {
    if (config.get().featureToggles.skipIntro && !this.skipIntroClicked) {
      if (this.shouldShowSkipIntro()) {
        this.setState({
          skipIntroPlay: true
        });
        changeState.call(this, playerUiStates.SKIP_INTRO);
      } else if (!this.shouldShowSkipIntro()) {
        this.setState({
          skipIntroPlay: false
        });
        changeState.call(this, playerUiStates.NONE);
      }
    }
  }

  /**
   * Returns true if the skip intro have to be shown. Otherwise returns false
   * @returns {Boolean}
   */
  shouldShowSkipIntro() {
    try {
      const { introStartSeconds, introEndSeconds } = locationState.credits;
      if (introEndSeconds) {
        return this.state.seekedTime >= introStartSeconds && this.state.seekedTime <= introEndSeconds;
      }
    } catch (e) {}
    return false;
  }

  /**
   * Returns true if the skip outro have to be shown. Otherwise returns false
   * @returns {Boolean}
   */
  shouldShowSkipOutro() {
    if (locationState.credits) {
      const { outroStartSeconds } = locationState.credits;
      if (outroStartSeconds) {
        return this.state.seekedTime >= outroStartSeconds && this.dismissOutroInterval === null;
      }
    }
    return false;
  }

  /**
   * Shows skip outro
   */
  async showSkipOutro() {
    if (config.get().featureToggles.skipOutro && !this.skipOutroClicked) {
      if (this.shouldShowSkipOutro()) {
        if (!this.isNextEpisodeRequested) {
          this.isNextEpisodeRequested = true;
          this.setState({
            skipOutroPlay: true,
            nextEpisode: await this.getNextEpisode()
          });
        }
        if (this.state.nextEpisode) {
          changeState.call(this, playerUiStates.SKIP_OUTRO);
          this.dismissOutroInterval = setInterval(() => this.skipOutroNextEpisode(), 1000);
        }
      }
    }
  }

  /**
   * Removes the skip outro screen
   */
  dismissOutro() {
    this.skipOutroClicked = true;
    changeState.call(this, playerUiStates.NONE);
    clearInterval(this.dismissOutroInterval);
    this.dismissOutroInterval = null;
    this.setState({
      skipOutroPlay: false
    });
  }

  /**
   * Manages the skip outro countdown
   */
  skipOutroNextEpisode() {
    this.setState({
      skipOutroCountDown: this.state.skipOutroCountDown - 1
    });
    if (this.state.skipOutroCountDown < 1 && locationState.videoType === "series") {
      this.skipOutroAction();
    }
  }

  /**
   * Go to the player position in which the intro ends
   */
  skipIntroAction() {
    this.skipIntroClicked = true;
    this.player.pause();
    this.player.seek(locationState.credits.introEndSeconds);
    this.skipIntroActionSeekedEventHandler();
  }

  /**
   * Callback for the skip outro poster
   */
  skipOutroAction() {
    this.dismissOutro();
    this.playEpisode(this.state.nextEpisode, true);
  }

  async getNextEpisode() {
    // FIXME: revisit episodes retrieval flow because this might delay too much the appearance of next episode screen.
    if (
      locationState.seriesId &&
      (!this.state.episodesList ||
        (this.state.episodesList && !this.state.episodesList.length) ||
        !locationState.episodesList ||
        (locationState.episodesList && !locationState.episodesList.length))
    ) {
      this.setState({ episodeSelectorLoading: !this.shouldShowSkipOutro() }); // If we're requesting next episode data from the skip outro we haven't to show loading
      const seriesData = await getSeasonsAndEpisodesList(locationState.seriesId);
      this.setState({ episodeSelectorLoading: false, ...seriesData });
    }

    const episodesList = this.getEpisodesList();
    const index = episodesList.findIndex(
      title =>
        this.state.tvSeasonEpisodeNumber === title.tvSeasonEpisodeNumber &&
        this.state.tvSeasonNumber === title.tvSeasonNumber
    );
    if (episodesList[index + 1]) {
      episodesList[index + 1].progress && (episodesList[index + 1].progress["playbackTime"] = 0);
    }
    nextEpisodeData = episodesList[index + 1];
    return episodesList[index + 1];
  }

  async playNextEpisode() {
    let nextEpisode;
    this.player.unload();
    this.setState({
      nextEpisodePlay: true
    });
    if (!this.state.nextEpisode) {
      nextEpisode = await this.getNextEpisode();
    }

    !!nextEpisode && this.setState({ nextEpisode });
    try {
      if (this.state.nextEpisode) {
        changeState.call(this, playerUiStates.NEXT_EPISODE);
        startNextEpisodeCountDown.call(this, this.state.nextEpisode);
      } else {
        this.setState({
          nextEpisodePlay: false
        });
        this.back();
      }
    } catch (e) {
      this.setState({
        nextEpisodePlay: false
      });
      this.back();
    }
  }

  /**
   * Plays new episode, from next episode or episode selector
   * @param {Object} episode Object with the info of the new episode
   * @param {Boolean} isNextEpisodeCountdownFinished Indicates if the countdown for go to the next episode has finished
   */
  async playEpisode(episode, isNextEpisodeCountdownFinished = false) {
    // Add check for user account status and free-to-air content
    const userAccountStatus = getAppState().userAccountStatus
    const isFreeToAir = episode.tags && isFVODFreeToAir(episode.tags)
    
    if (!isUserAccountActive(userAccountStatus) && !isFreeToAir) {
        // Show error modal for non-subscribers trying to access premium content
        this.showErrorModal(
            i18n.get("global.errors.account.invalidStatus")
        );
        return;
    }
    
    // If episode selected is the same as the one being played, it will exit episode selector and resume playback.

    this.setState({
      playerBuffering: true,
      nextEpisodePlay: false,
      skipOutroCountDown: config.get().player.skipOutroCountDown
    });

    this.clearUserMediaCached();
    this.skipIntroClicked = false;
    this.skipOutroClicked = false;
    this.isNextEpisodeRequested = false;
    const titleFor4K =
      this.is4KSessionSelectedQuality() &&
      !!episode["4kProgramId"] &&
      (await sdk.mediaManager.getTitle(episode.id, { is4K: true }));
    const has4K = titleFor4K && this.props.applicationState.supports4K;
    const media = has4K ? titleFor4K.title4K.mediaContent[0] : episode.mediaContent[0];
    locationState.filmstrip = media.content.filmstrip || null;
    const playbackTime = (episode.progress && episode.progress.playbackTime) || 0;
    sdk.playerManager.setCurrentTime(playbackTime);
    const { releasePid, releaseUrl, streamingUrl, duration } = media.content.video;
    const newConfig = {
      releasePids: releasePid,
      releaseUrl: releaseUrl,
      manifest: streamingUrl,
      videoType: "series",
      playbackTime,
      id: episode.id,
      has4K,
      externalSubtitles: media.content.subtitles,
      seasonNumber: episode.tvSeasonNumber,
      episodeNumber: episode.tvSeasonEpisodeNumber,
      tvSeasonEpisodeNumber: episode.tvSeasonEpisodeNumber,
      tvSeasonNumber: episode.tvSeasonNumber,
      ...(config.get().featureToggles.skipIntro &&
        locationState.videoType === "series" && {
          credits: await this.getCredits(media.credits, media.mediaGuid)
        }),
      playbackAnalytics: {
        newEpisode: true,
        title: this.state.seriesTitle,
        season: episode.tvSeasonNumber || 0,
        episode: episode.tvSeasonEpisodeNumber || 0,
        mediaGuid: media.mediaGuid,
        duration: duration,
        genre: locationState.genre,
        is4KEnabled: this.is4KSessionSelectedQuality() && has4K,
        playFrom:
          (this.state.activePanel === playerUiStates.NEXT_EPISODE && PLAY_FROM_NEXT_EPISODE) ||
          (this.state.activePanel === playerUiStates.EPISODE_SELECTOR && PLAY_FROM_EPISODE_SELECTOR),
        resume: !!playbackTime
      }
    };
    this.playbackPercentages = [...config.get().player.playbackPercentages];

    const newState = {
      title: episode.title,
      description: episode.shortDescription,
      episodeLabel: getEpisodeLabel(episode.tvSeasonNumber, episode.tvSeasonEpisodeNumber),
      tvSeasonNumber: episode.tvSeasonNumber,
      tvSeasonEpisodeNumber: episode.tvSeasonEpisodeNumber,
      episodeSelectorLoading: false,
      player: null,
      isPlaying: true,
      isSeeked: false,
      seekedTime: 0,
      duration: "00:00",
      currentTime: "00:00",
      currentTimeInSeconds: 0,
      totalTimeInSeconds: 0,
      nextEpisodePlay: false,
      skipIntroPlay: false,
      skipOutroPlay: false,
      playbackRate: 0,
      margin: i18n.getDirection() === "ltr" ? 2 : 1,
      selectBtn: 0,
      totalBtns: 4,
      textLabels: [
        "",
        i18n.get("global.back"),
        i18n.get("pages.player.settings.audioSubtitles"),
        i18n.get("global.playFromBeginning"),
        i18n.get("global.media.episodes")
      ],
      playerBuffering: true,
      openTracksAndAudio: false,
      showFilmStrip: false,
      subtitleTracks: null,
      showPauseScreen: false,
      showPlayerControls: true,
      isPlayFromEpisodes: true,
      audioTracks: null,
      filmstripData: null,
      nextEpisode: null,
      currentSubtitleID: null,
      showEpisodesLists: false
    };
    this.filmstrip = null;
    this.playbackIconName = "";
    Object.assign(locationState, newConfig);
    this.player.unload();
    this.updateConfig();
    Logger.log(locationState.manifest, "Manifest");
    this.setState(newState, async () => {
      this.setupPlayer();
    });
  }

  clearUserMediaCached() {
    this.props.applicationState.userMediaCached = null;
  }

  is4KSessionSelectedQuality() {
    return sessionStorage && JSON.parse(sessionStorage.getItem("seriesPlaying4K"));
  }

  async getCredits(credits, mediaGuid) {
    return credits || (await this.getTimeMarkers(mediaGuid));
  }

  /**
   * Returns time markers from server
   * @returns {Object}
   */
  async getTimeMarkers(mediaGuid) {
    return (await sdk.mediaManager.getTitleTimeMarkers({ mediaGuid })) || {};
  }

  togglePausePlay() {
    if (!locationState.isLive) {
      if (!this.state.isSeeked) {
        if (this.state.isPlaying === false) {
          this.setState({
            isPlaying: true,
            selectBtn: 0,
            showFilmStrip: false,
            openTracksAndAudio: false,
            showEpisodesLists: false
          });
          this.player.play();
          clearInterval(this.showPauseScreenInterval);
          this.setState({
            showPauseScreen: false
          });
          this.showControls();
        } else {
          this.setState({
            isPlaying: false,
            selectBtn: 0,
            showFilmStrip: false,
            openTracksAndAudio: false,
            showEpisodesLists: false
          });
          this.player.pause();
          sdk.playerManager.pause();

          this.showPauseScreenInterval = setInterval(() => {
            this.setState({
              showPauseScreen: true
            });
          }, this.timeToShowPauseScreen);
          this.showControls();
        }
      } else {
        const playState = this.state.isPlaying;
        playState ? this.player.pause() : this.player.play();
        this.setState({ isPlaying: !playState });
        if (this.state.showFilmStrip) {
          this.player.pause();
          this.player.seek(this.state.seekedTime);
          // setTimeout(() => {
          //   this.player.play();
          // }, 3000);
          this.togglePausePlaySeekedEventHandler();
        }
      }
    }
  }

  pausedSeek() {
    this.setState({
      isPlaying: false
    });
    this.player.pause();
    sdk.playerManager.pause();
  }

  seekLeft() {
    //10 seconds back
    this.playbackIconName = "rewind";
    if (this.state.isPlaying === true) {
      this.pausedSeek();
    }
    if (this.state.seekedTime > 0) {
      this.setState({
        showFilmStrip: true,
        seekedTime: this.state.seekedTime - 10,
        isSeeked: true
      });
      // time should updated in view instant when seek left is pressed
      let time = this.toMinutesAndSeconds(this.state.seekedTime);
      this.setState({
        currentTime: time
      });

      if (!this.state.filmstripData) {
        // this.getFilmStrip();
      } else {
        onStateEnter[playerUiStates.FILMSTRIP].call(this);
      }
    }
  }
  seekRight() {
    this.playbackIconName = "forward";
    // 10 seconds forward
    if (this.state.isPlaying === true) {
      this.pausedSeek();
    }
    if (this.state.seekedTime < this.player.getDuration()) {
      this.setState({
        showFilmStrip: true,
        seekedTime: this.state.seekedTime + 10,
        isSeeked: true
      });
      // time should updated in view instant when seek right is pressed
      let time = this.toMinutesAndSeconds(this.state.seekedTime);
      this.setState({
        currentTime: time
      });

      if (!this.state.filmstripData) {
        // this.getFilmStrip();
      } else {
        onStateEnter[playerUiStates.FILMSTRIP].call(this);
      }
    }
  }
  playerErrorEventHandler = event => {
    let errorCode = getErrorCode(event.code);
    let error = {
      code: errorCode,
      data: {
        name: event.name
      }
    };
    this.playerErrorHandler(error);
  };
  togglePausePlaySeekedEventHandler = event => {
    this.setState({
      isPlaying: true,
      isSeeked: false,
      showFilmStrip: false,
      showEpisodesLists: false
    });
    this.player.play();
    this.showControls();
    sdk.playerManager.seek();
  };
  skipIntroActionSeekedEventHandler = event => {
    this.setState({
      isSeeked: false,
      skipIntroPlay: false
    });
    this.player.play();
  };
  playFromStartSeekedEventHandler = event => {
    this.setState({
      currentTime: "00:00",
      isSeeked: false
    });
    this.player.play();
    sdk.playerManager.seek();
  };

  handleRemoteSeekedEventHandler = event => {
    this.setState({
      currentTime: "00:00",
      isSeeked: false
    });
    this.player.play();
    sdk.playerManager.seek();
  };

  seekEventHandler = e => {
    sdk.playerManager.setCurrentTime(e.seekTarget * 1000);
    clearInterval(this.showPauseScreenInterval);
    clearTimeout(this.showHidePlayerControls);

    if (!locationState.isLive) {
      sdk.playerManager.seek();
      this.setState({
        seekedTime: e.seekTarget,
        currentTime: this.toMinutesAndSeconds(e.seekTarget)
      });

      this.player.on(PlayerEvent.Seeked, this.seekedHandler);

      this.setState({ playerBuffering: true, isSeeked: true }, () => {
        this.player.pause();
      });

      // setTimeout(() => {}, 2000)
    }
  };

  seekedHandler = e => {
    const playState = this.state.isPlaying;
    if (playState) {
      sdk.playerManager.play();
      this.setState({ playerBuffering: false, isSeeked: false, showFilmStrip: false }, () => {
        this.player.play();
      });
    } else {
      sdk.playerManager.pause();
      this.setState({ playerBuffering: false, isSeeked: false, showFilmStrip: false }, () => {
        this.player.pause();
      });
    }
  };

  playEventHandler = event => {
    let time = this.toMinutesAndSeconds(this.player.getDuration());
    //sdk.playerManager.configSuccess(this.config);
    this.showControls();
    Logger.log("this.mounted value is:true", "Player.onPlay");
    let resumeFrom = this.config.playbackTime !== 0 ? this.config.playbackTime : 0;
    if (resumeFrom !== 0 && this.state.isTryToplayFromResume === true) {
      this.setState({
        currentTime: this.toMinutesAndSeconds(resumeFrom)
      });
    }
    this.setState({
      duration: time,
      playerBuffering: false,
      playbackState: "play",
      nextEpisodePlay: false,
      totalTimeInSeconds: this.player.getDuration()
    });
    sdk.playerManager.play();
  };

  timeChangedEventHandler = event => {
    this.setState({
      seekedTime: this.player.getCurrentTime()
    });
    let time = this.toMinutesAndSeconds(this.player.getCurrentTime());
    this.setState({
      currentTime: time,
      currentTimeInSeconds: this.player.getCurrentTime()
    });

    // send current time in milliseconds for heartbeat
    if (!this.state.showFilmStrip) {
      sdk.playerManager.setCurrentTime(this.player.getCurrentTime() * 1000);
    }
    locationState.videoType !== "trailer" && this.state.totalTimeInSeconds && this.checkTimeForSendEvent();
    if (locationState.videoType === "series") {
      this.showSkipIntro();
      this.showSkipOutro();
    }
  };

  playEventSeekedEventHandler = event => {
    this.player.play();
    this.setState({
      isTryToplayFromResume: false
    });
  };

  playbackFinishedEventHandler = event => {
    if (locationState.videoType !== "series") {
      sdk.playerManager.stop();
      this.backHandler();
    } else if (locationState.videoType === "series") {
      this.playNextEpisode();
    }
  };

  playFromStart() {
    this.player.pause();
    this.setState(
      {
        seekedTime: 0
      },
      () => this.player.seek(this.state.seekedTime)
    );
    setTimeout(() => {
      this.player.play();
    }, 3000);
    this.playFromStartSeekedEventHandler();
  }

  getCurrentTimestamp() {
    return this.state.seekedTime * 1000 || 0;
  }

  shouldShowLoading() {
    return this.state.playerBuffering;
  }

  getSeasonsList() {
    const { seasonsList } = this.state;
    return (
      (locationState.seasonsList && locationState.seasonsList.length && locationState.seasonsList) ||
      (seasonsList && seasonsList.length && seasonsList)
    );
  }

  getEpisodesList() {
    const { episodesList } = this.state;
    return (
      (locationState.episodesList && locationState.episodesList.length && locationState.episodesList) ||
      (episodesList && episodesList.length && episodesList)
    );
  }

  getFilmStrip() {
    locationState !== "trailer" &&
      sdk.mediaManager
        .getFilmstripData(locationState.filmstrip)
        .then(filmstripData => this.setState({ filmstripData }));
  }

  // convert given time to hh:mm:ss
  toMinutesAndSeconds(elapsedTime) {
    console.log(elapsedTime);
    // error handling
    if(!elapsedTime){return "00:00:00"}

    // convert to hours, minutes and seconds
    let hours = Math.trunc(elapsedTime / 60 / 60);
    elapsedTime -= hours * 60 * 60;
    let minutes = Math.trunc(elapsedTime / 60);
    let seconds = Math.trunc(elapsedTime % 60);

    // format the output
    let hoursString = hours ? `${hours}:` : "";
    let minutesString = minutes < 10 ? `0${minutes}` : minutes;
    let secondsString = seconds < 10 ? `0${seconds}` : seconds;

    // return the output
    return `${hoursString}${minutesString}:${secondsString}`;
  }

  shouldRenderPlaybackRate() {
    return this.state.showFilmStrip && (this.state.playbackRate > 0 || !this.hasThumbnails());
  }

  hasThumbnails() {
    return (
      this.state.filmstripData && this.state.filmstripData.thumbnails && !!this.state.filmstripData.thumbnails.length
    );
  }

  destroyPlayer() {
    if (this.player != null) {
      this.player.destroy();
      this.setState({
        ...this.state,
        player: null
      });
    }
  }
  scrollUpDown(event) {
    this.wheelState = "active";
    if (event.deltaY > 0) {
      // down wheel moves
      this.props.applicationState.currentFocus === SEASONFOCUS && this.props.setFocus(EPISODEFOCUS);
    } else if (event.deltaY < 0) {
      // up wheel moves
      this.props.applicationState.currentFocus === EPISODEFOCUS && this.props.setFocus(SEASONFOCUS);
    }
  }

  render() {
    const { videoType, isLive } = locationState;
    console.log('videoType', videoType);
    console.log('this.state.playerBuffering', this.state.playerBuffering);
    console.log('this.state.isPlayerLoaded ', this.state.isPlayerLoaded );
    console.log('this.state.showPlayerControls', this.state.showPlayerControls);
    console.log('this.state.showEpisodesLists', this.state.showEpisodesLists);
    if(!this.shouldShowLoading() &&
    this.state.isPlayerLoaded &&
    !this.state.showEpisodesLists &&
    this.state.showPlayerControls ) {
      console.log("<<<<<<<<<  SHowing episode Icon   >>>>>>>>>>>>>>>>>>")
    }

    return !!this.state.errorMessage ? (
      <Modal
        headingText={this.state.errorMessageHeading || ""}
        mainText={this.state.errorMessage}
        headerIcon={<Logo />}
      >
        <ButtonFocus
          label={i18n.get("global.close").toUpperCase()}
          focusPath="errorBackButton"
          onEnterPress={this.state.isMaxDeviceReached === true ? this.maxDeviceBack.bind(this) : this.back}
          onMouseUp={this.state.isMaxDeviceReached === true ? this.maxDeviceBack.bind(this) : this.back}
          onRef={ref => (this.errorButtonClose = ref)}
          size="small"
          displayBlock={true}
          spacing="xsmall"
        />
      </Modal>
    ) : (
      <Wrapper onClick={this.showProgressBar.bind(this)}>
        {this.shouldShowLoading() && <Loading overlay />}
        {videoType !== "trailer" &&
          !this.state.playerBuffering &&
          !this.state.showEpisodesLists &&
          !this.state.isSeeked &&
          this.state.showPauseScreen &&
          this.state.isPlaying === false && (
            <PauseScreen
              heading={i18n.get("pages.player.youAreWatching")}
              contentTitle={this.state.title}
              seriesTitle={this.state.seriesTitle}
              episodeLabel={this.state.episodeLabel}
              contentDescription={this.state.description}
            />
          )}
        {this.state.showEpisodesLists && !this.shouldShowLoading() && this.getSeasonsList() && this.getEpisodesList() && (
          <div
            onWheel={e => {
              this.scrollUpDown(e);
            }}
          >
            <EpisodesSelectorScreen
              seasonsList={this.getSeasonsList()}
              episodesList={this.getEpisodesList()}
              seasonSelected={this.state.tvSeasonNumber}
              episodeSelected={this.state.tvSeasonEpisodeNumber}
              onEnterPress={this.playEpisode}
              onMouseUp={this.playEpisode}
              dataSnUp={""}
              dataSnDown={""}
              fromDetailPage={true}
              fromPlayer={true}
              MagicRemoteStatus={this.wheelState === "active" ? true : false}
              showArrows={this.wheelState === "active" ? true : false}
              currentFocus={this.props.applicationState.currentFocus}
              direction={i18n.getDirection()}
              slideMarginStart={resolution.carousel.slideMarginStart.episodeSelector}
            />
          </div>
        )}
        {this.state.nextEpisode &&
          this.state.nextEpisode.images.screenshot &&
          this.state.nextEpisode.tvSeasonNumber &&
          this.state.nextEpisode.tvSeasonEpisodeNumber &&
          this.state.nextEpisode.title &&
          this.state.skipOutroPlay === false &&
          this.state.nextEpisodePlay &&
          videoType === "series" &&
          this.state.nextEpisode && (
            <NextEpisode
              className="next-episode"
              focusPath="nextEpisode"
              imageUrl={this.state.nextEpisode.images.screenshot}
              countdownText={i18n.get("pages.player.nextEpisodeWillStartIn", this.state.nextEpisodeCountDown)}
              episodeLabel={getEpisodeLabel(
                this.state.nextEpisode.tvSeasonNumber,
                this.state.nextEpisode.tvSeasonEpisodeNumber
              )}
              contentTitle={this.state.nextEpisode.title}
              nextEpisodeTitle={this.state.nextEpisode}
              onEnterPress={this.playEpisode}
              onMouseUp={this.playEpisode}
              backHandler={this.back}
              buttonLabel={i18n.get("global.back").toUpperCase()}
              position="center"
              buttonFocusPath="buttonBackNextEpisode"
            />
          )}
        {this.state.skipIntroPlay === true && videoType === "series" && (
          <ButtonSkipIntroFocus
            className="focused introbuttonfix"
            label={i18n.get("pages.player.skipIntro").toUpperCase()}
            onMouseUp={this.skipIntroAction}
            focusPath={SKIP_INTRO_BUTTON_FOCUS_PATH}
            size="small"
            buttonType="primary"
          />
        )}
        {this.state.skipOutroPlay === true && videoType === "series" && this.state.nextEpisode && (
          <NextEpisode
            className="next-episode"
            focusPath={SKIP_OUTRO_DISMISS_BUTTON_FOCUS_PATH}
            imageUrl={this.state.nextEpisode.images.screenshot}
            countdownText={i18n.get("pages.player.nextEpisodeWillStartIn", this.state.skipOutroCountDown)}
            episodeLabel={getEpisodeLabel(
              this.state.nextEpisode.tvSeasonNumber,
              this.state.nextEpisode.tvSeasonEpisodeNumber
            )}
            contentTitle={this.state.nextEpisode.title}
            onEnterPress={this.skipOutroAction}
            onMouseUp={this.skipOutroAction}
            backHandler={this.dismissOutro}
            buttonLabel={i18n.get("pages.player.dismissButton").toUpperCase()}
            position="bottomRight"
            buttonFocusPath={BUTTON_DISMISS_OUTRO_FOCUS_PATH}
          />
        )}
        {!this.shouldShowLoading() &&
          this.state.openTracksAndAudio &&
          this.state.showPlayerControls &&
          videoType !== "trailer" && (
            <Tracks
              audioTracks={this.state.audioTracks}
              subtitleTracks={this.state.subtitleTracks}
              audioTitle={i18n.get("pages.player.audio")}
              subtitlesTitle={i18n.get("global.subtitles")}
              onTrackSelected={this.selectTrack}
            />
          )}
        {!this.shouldShowLoading() && !this.state.showEpisodesLists && this.state.showPlayerControls && (
          <Title
            className="zindex playerTitle"
            title={this.state.seriesTitle || this.state.title}
            episodeLabel={this.state.episodeLabel}
          />
        )}
        {!this.shouldShowLoading() && this.shouldRenderPlaybackRate() && videoType !== "trailer" && (
          <PlaybackRate
            rate={this.state.playbackRate || undefined}
            iconName={this.playbackIconName || undefined}
            text={!this.hasThumbnails() ? i18n.get("pages.player.pressOkButtonToResume") : undefined}
          />
        )}
        {!this.shouldShowLoading() &&
          videoType !== "trailer" &&
          this.state.showFilmStrip === true &&
          this.state.showPlayerControls &&
          this.state.filmstripData &&
          this.state.filmstripData.thumbnails &&
          this.state.filmstripData.thumbnails.length > 0 &&
          !isLive &&
          !this.state.playerBuffering && (
            <FilmstripFocus
              focusPath={"filmstrip"}
              thumbnails={this.state.filmstripData.thumbnails}
              initialThumbnail={
                this.state.filmstripData.thumbnails.length > this.state.currentFilmstripPosition &&
                this.state.currentFilmstripPosition
              }
              filmstripCarousel={carousel => (this.filmstrip = carousel)}
              direction={i18n.directions.LEFT_TO_RIGHT}
            />
          )}

        {!this.shouldShowLoading() &&
          this.state.isPlayerLoaded &&
          !this.state.showEpisodesLists &&
          this.state.showPlayerControls && (
            <PlayerShadow style={{ zIndex: 9 }}>
              {
                <ControlsSettingsStyled>
                  <ControlSettingsBtn xmlns="http://www.w3.org/2000/svg" onClick={this.backHandler.bind(this)}>
                    <FillBtnBack className={this.state.selectBtn === 1 ? "activePlayer" : null} />
                  </ControlSettingsBtn>
                  {videoType !== "trailer" && !this.state.playerBuffering && (
                    <ControlSettingsBtn xmlns="http://www.w3.org/2000/svg" onClick={this.openLanguage.bind(this)}>
                      <FillBtnLanguage className={this.state.selectBtn === 2 ? "activePlayer" : null} />
                    </ControlSettingsBtn>
                  )}
                  {videoType !== "trailer" && !this.state.playerBuffering && !isLive && (
                    <ControlSettingsBtn xmlns="http://www.w3.org/2000/svg" onClick={this.playFromBegining.bind(this)}>
                      <FillBtnStart className={this.state.selectBtn === 3 ? "activePlayer" : null} />
                    </ControlSettingsBtn>
                  )}
                  {videoType === "series" && !this.state.playerBuffering && (
                    <ControlSettingsBtn xmlns="http://www.w3.org/2000/svg" onClick={this.openEpisodeList.bind(this)}>
                      <FillBtnEpisode className={this.state.selectBtn === 4 ? "activePlayer" : null} />
                    </ControlSettingsBtn>
                  )}
                </ControlsSettingsStyled>
              }
              {
                <LabelDiv
                  style={
                    i18n.getDirection() === "ltr"
                      ? { marginLeft: this.state.margin + "em" }
                      : { marginRight: this.state.margin + "em" }
                  }
                >
                  <LabelStyled>{this.state.textLabels[this.state.selectBtn]}</LabelStyled>
                </LabelDiv>
              }
              {this.state.showPauseScreen === false && this.state.skipIntroPlay === false && (
                <LowerPlayerControls
                  dir="ltr"
                  onMouseOver={this.showBar.bind(this)}
                  onMouseOut={this.showControls.bind(this)}
                >
                  {!isLive && (
                    <PlayPauseToggle id="playpause" onClick={this.togglePausePlay.bind(this)}>
                      <ToggleBtn xmlns="http://www.w3.org/2000/svg">
                        {!this.state.isPlaying && (
                          <FillBtnPlay className={this.state.selectBtn === 0 ? "activePlayer" : null} />
                        )}
                        {this.state.isPlaying && (
                          <FillBtnPause className={this.state.selectBtn === 0 ? "activePlayer" : null} />
                        )}
                      </ToggleBtn>
                    </PlayPauseToggle>
                  )}
                  {!isLive && (
                    <CurrentPlay currentState={this.state.currentTime.lastIndexOf(":")}>
                      <CurrentAndTotalPlaySpan>
                        {this.state.currentTime !== "NaNNaN:NaN" ? this.state.currentTime : "00:00"}
                      </CurrentAndTotalPlaySpan>
                    </CurrentPlay>
                  )}
                  <ProgressBarContainer>
                    <ProgressBar value={this.state.seekedTime} max={this.state.totalTimeInSeconds} />
                  </ProgressBarContainer>
                  {!isLive && (
                    <TotalPlayTime>
                      <CurrentAndTotalPlaySpan>{this.state.duration}</CurrentAndTotalPlaySpan>
                    </TotalPlayTime>
                  )}
                </LowerPlayerControls>
              )}
            </PlayerShadow>
          )}
        <PlayerDiv id="av-player" isRTL={this.appFlow === "rtl" ? true : false} />
      </Wrapper>
    );
  }
}
export default withAppState(withSubtheme(PlayerBitMovin));
